var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="no-rates-found padding-all-lg">\n  <div class=\'messages-content\'>\n    <p class="tip">\n        <i class="ra ra-info-circle margin-right-sm margin-top-sm align-top"></i>\n        <span> We did not find any matches at this time.</span>\n      </p>\n      <div class="tip-content">\n        <b>Please adjust your search</b>\n        <p>You might find more rates by <a href=\'#\' class=\'js-reset-search\'>editing your search.</a></p>\n      </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/home_equity_rate_table_message.jst.ejs